import * as buttons from 'smg/buttons';
import { UpdateCurrentUser, UpdateCurrentUserPassword } from 'smg/customer-api/currentuser';
import * as models from 'smg/customer-api/models';
import * as paymentmethods from 'smg/customer-api/paymentoptions';
import * as session from 'smg/customer-api/session';
import * as shippingoptions from 'smg/customer-api/shippingoptions';
import * as errors from 'smg/errors';
import { ReportValidity } from 'smg/form';
import * as phone from 'smg/phone';
import * as template from 'smg/template';
import * as toast from 'smg/toast';
import { AccountReady } from '../account-session';
import { PromptNewPaymentOption } from '../payments';
import * as shippingFunctions from '../shippingoptions';

void main();

async function main() {
    if (await AccountReady) {
        return;
    }

    const sess = await session.Session();

    // PROFILE & EDIT PROFILE

    const fullName = document.querySelector('#user-name') as HTMLElement;
    const email = document.querySelector('#user-email') as HTMLElement;
    const phoneDisplay = document.querySelector('#user-phone') as HTMLElement;
    const password = document.querySelector('#user-password') as HTMLElement;

    fullName.textContent = sess.user.fullName();
    email.textContent = sess.user.emailAddress.email;
    phoneDisplay.textContent = sess.user.phoneNumber.phone;
    password.textContent = '***';

    const userProfileForm = document.querySelector('#user-profile-form') as HTMLFormElement;
    const fieldset = userProfileForm.querySelector('fieldset') as HTMLFieldSetElement;

    const saveBtn = document.querySelector('#save-user-profile-btn') as HTMLButtonElement;
    const profileInputs = Array.from(userProfileForm.querySelectorAll('input'));

    const editNameBtn = document.querySelector('#edit-name') as HTMLElement;
    const nameInputs = document.querySelector('#name-inputs-wrap') as HTMLElement;
    const editFirstNameInput = document.querySelector('#edit-first-name-input') as HTMLInputElement;
    const editLastNameInput = document.querySelector('#edit-last-name-input') as HTMLInputElement;
    const cancelNameEdit = document.querySelector('#cancel-name-edit') as HTMLElement;

    const editEmailBtn = document.querySelector('#edit-email') as HTMLElement;
    const emailInput = document.querySelector('#user-email-input-wrap') as HTMLElement;
    const editEmailInput = document.querySelector('#edit-email-input') as HTMLInputElement;
    const cancelEmailEdit = document.querySelector('#cancel-email-edit') as HTMLElement;

    const editPhoneBtn = document.querySelector('#edit-phone') as HTMLElement;
    const phoneInput = document.querySelector('#user-phone-input-wrap') as HTMLElement;
    const editPhoneInput = document.querySelector('#edit-phone-input') as HTMLInputElement;
    const cancelPhoneEdit = document.querySelector('#cancel-phone-edit') as HTMLElement;

    const editPasswordBtn = document.querySelector('#edit-password') as HTMLElement;
    const passwordInputs = document.querySelector('#user-password-inputs-wrap') as HTMLElement;
    const editPasswordInput = document.querySelector('#edit-password-input') as HTMLInputElement;
    const confirmPasswordInput = document.querySelector('#confirm-password-input') as HTMLInputElement;
    const cancelPasswordEdit = document.querySelector('#cancel-password-edit') as HTMLElement;

    const checkOpenEdits = (arr: HTMLInputElement[]) => {
        for (const v of arr) {
            if (v.disabled) {
                continue;
            } else {
                return true;
            }
        }
        return false;
    };

    const checkConfirm = () => {
        if (editPasswordInput.value === confirmPasswordInput.value) {
            confirmPasswordInput.setCustomValidity('');
        } else {
            confirmPasswordInput.setCustomValidity('Passwords must match');
        }
    };

    const editOrCancelClicked = (btnWasEdit: boolean, staticEl: HTMLElement, inputsContainer: HTMLElement, inputs: HTMLInputElement[], editBtn: HTMLElement, cancelBtn: HTMLElement) => {
        if (btnWasEdit) {
            staticEl.classList.add('d-none');
            inputsContainer.classList.remove('d-none');
            for (const input of inputs) {
                input.disabled = false;
                input.required = true;
            }
            editBtn.classList.add('d-none');
            cancelBtn.classList.remove('d-none');
        } else {
            staticEl.classList.remove('d-none');
            inputsContainer.classList.add('d-none');
            for (const input of inputs) {
                input.value = '';
                input.disabled = true;
                input.required = false;
            }
            editBtn.classList.remove('d-none');
            cancelBtn.classList.add('d-none');

            if (!checkOpenEdits(profileInputs)) {
                saveBtn.classList.add('d-none');
            } else {
                saveBtn.classList.remove('d-none');
            }
        }
    };

    editNameBtn.addEventListener('click', e => {
        e.preventDefault();
        saveBtn.classList.remove('d-none');

        editOrCancelClicked(true, fullName, nameInputs, [editFirstNameInput, editLastNameInput], editNameBtn, cancelNameEdit);
    });

    cancelNameEdit.addEventListener('click', e => {
        e.preventDefault();

        editOrCancelClicked(false, fullName, nameInputs, [editFirstNameInput, editLastNameInput], editNameBtn, cancelNameEdit);
    });

    editEmailBtn.addEventListener('click', e => {
        e.preventDefault();
        saveBtn.classList.remove('d-none');

        editOrCancelClicked(true, email, emailInput, [editEmailInput], editEmailBtn, cancelEmailEdit);
    });

    cancelEmailEdit.addEventListener('click', e => {
        e.preventDefault();

        editOrCancelClicked(false, email, emailInput, [editEmailInput], editEmailBtn, cancelEmailEdit);
    });

    editPhoneBtn.addEventListener('click', e => {
        e.preventDefault();
        saveBtn.classList.remove('d-none');

        editOrCancelClicked(true, phoneDisplay, phoneInput, [editPhoneInput], editPhoneBtn, cancelPhoneEdit);
    });

    cancelPhoneEdit.addEventListener('click', e => {
        e.preventDefault();

        editOrCancelClicked(false, phoneDisplay, phoneInput, [editPhoneInput], editPhoneBtn, cancelPhoneEdit);
    });

    editPasswordBtn.addEventListener('click', e => {
        e.preventDefault();
        saveBtn.classList.remove('d-none');

        editOrCancelClicked(true, password, passwordInputs, [editPasswordInput, confirmPasswordInput], editPasswordBtn, cancelPasswordEdit);
    });

    cancelPasswordEdit.addEventListener('click', e => {
        e.preventDefault();

        editOrCancelClicked(false, password, passwordInputs, [editPasswordInput, confirmPasswordInput], editPasswordBtn, cancelPasswordEdit);
    });

    editPasswordInput.addEventListener('input', () => checkConfirm());
    confirmPasswordInput.addEventListener('input', () => checkConfirm());

    const p = new phone.Phone(editPhoneInput);

    userProfileForm.noValidate = true;
    userProfileForm.addEventListener('submit', async e => {
        e.preventDefault();

        if (!ReportValidity(userProfileForm)) {
            const validityMessages = Array.from(userProfileForm.querySelectorAll('.invalid-feedback'));
            for (const validityMessage of validityMessages) {
                validityMessage.classList.add('mt-0');
            }
            if (editFirstNameInput.nextElementSibling?.classList.contains('invalid-feedback')) {
                editFirstNameInput.classList.remove('mb-5');
            }
            if (editPasswordInput.nextElementSibling?.classList.contains('invalid-feedback')) {
                editPasswordInput.classList.remove('mb-5');
            }
            return false;
        }

        fieldset.disabled = true;
        buttons.Start(saveBtn);

        const updatedUser = UpdateCurrentUser({
            firstName: editFirstNameInput.disabled ? sess.user.firstName : editFirstNameInput.value,
            lastName: editLastNameInput.disabled ? sess.user.lastName : editLastNameInput.value,
            company: sess.user.company,
            email: editEmailInput.disabled ? sess.user.emailAddress.email : editEmailInput.value,
            phone: editPhoneInput.disabled ? sess.user.phoneNumber.phone : await p.format(),
        }).then(() => undefined);

        let updateUserPassword: Promise<void> | undefined;
        if (!editPasswordInput.disabled && !confirmPasswordInput.disabled) {
            updateUserPassword = UpdateCurrentUserPassword({
                newPassword: editPasswordInput.value,
                confirmPassword: confirmPasswordInput.value,
            });
        }

        const updatePromises: Promise<void>[] = [updatedUser];

        if (updateUserPassword) {
            updatePromises.push(updateUserPassword);
        }

        try {
            await Promise.all(updatePromises);

            for (const input of profileInputs) {
                input.disabled = true;
            }
            session.ClearCache();
            buttons.Stop(saveBtn);
            toast.Success('Updated Information');
        } catch (err) {
            errors.ShowError(err, userProfileForm);
        }
    });

    // ADDRESSES
    const { shippingOptions } = await shippingoptions.ShippingOptions({
        'data': 'address',
        'sort': 'created asc',
        'q': 'has:email has:phone has:fullName has:addressLine1 has:city has:countryID has:zip',
    });

    function drawAddresses(shippingOptionsInit: models.IShippingOption[]) {
        const addressWrap = document.querySelector('#addresses-container') as HTMLElement;

        for (const shippingOptionInit of shippingOptionsInit) {
            const shippingOption = new models.ShippingOption(shippingOptionInit);
            const shippingAddress = shippingOption.address;
            if (!shippingAddress) {
                continue;
            }

            const templateEl = template.Clone(document.querySelector('#address-template') as HTMLTemplateElement);
            const templateElChild = templateEl.querySelector('#address-elements') as HTMLElement;
            if (shippingAddress.organization) {
                const company = templateEl.querySelector('#shipping-company') as HTMLElement;
                company.textContent = shippingAddress.organization;
            }
            const name = templateEl.querySelector('#shipping-name') as HTMLElement;
            const addressLineOne = templateEl.querySelector('#shipping-addressline-one') as HTMLElement;
            const addressLineTwo = templateEl.querySelector('#shipping-addressline-two') as HTMLElement;
            const cityStateZip = templateEl.querySelector('#shipping-city-state-zip') as HTMLElement;
            const city = cityStateZip.querySelector('#shipping-city') as HTMLElement;
            const state = cityStateZip.querySelector('#shipping-state') as HTMLElement;
            const zip = cityStateZip.querySelector('#shipping-zip') as HTMLElement;
            const country = templateEl.querySelector('#shipping-country') as HTMLElement;
            const deleteAddressBtn = templateEl.querySelector('#delete-address') as HTMLElement;

            deleteAddressBtn.addEventListener('click', () => {
                void shippingoptions.DeleteShippingOption(shippingOption.id || '').then(() => {
                    templateElChild.parentElement?.removeChild(templateElChild);
                    toast.Success('Removed Address');
                });
            });

            name.textContent = shippingAddress.fullName || '';
            addressLineOne.textContent = shippingAddress.addressLine1 || '';
            addressLineTwo.textContent = shippingAddress.addressLine2 || '';
            city.textContent = shippingAddress.city ? `${shippingAddress.city},` : '';
            state.textContent = shippingAddress.state?.name ? `${shippingAddress.state.name},` : '';
            zip.textContent = shippingAddress.postalCode || '';
            country.textContent = shippingAddress.country?.name || '';

            // Checkout drops options whose stored phone fails the server tel validator; let the customer fix it here.
            if (!phone.IsValid(shippingAddress.phoneNumber?.phone ?? '')) {
                templateElChild.appendChild(phone.InvalidPhoneNote());
            }

            // Saving an address the customer already has returns that row, so its card is replaced, not repeated.
            templateElChild.dataset.shippingOptionId = shippingOption.id ?? '';
            addressWrap.querySelector(`[data-shipping-option-id="${CSS.escape(shippingOption.id ?? '')}"]`)?.remove();
            addressWrap.insertBefore(templateEl, addressWrap.lastElementChild);
        }
    }
    const newAddressBtn = document.querySelector('#new-address') as HTMLElement;

    newAddressBtn.addEventListener('click', () => {
        void shippingFunctions.PromptNew(sess.user).then(resp => drawAddresses([models.ShippingOption.fromJSON(resp)]));
    });

    drawAddresses(shippingOptions);

    //  PAYMENT METHODS
    const { paymentOptions } = await paymentmethods.PaymentOptions({
        'data': 'address,' +
            'creditCardFirst6,creditCardLast4,creditCardExpirationDate,key,paymentOptionTypeID,bankType,accountType',
        'sort': 'created asc',
        'q': 'has:email has:phone has:fullName has:addressLine1 has:city has:countryID has:zip valid:yes',
    });

    function drawPaymentMethods(paymentOptionsInit: models.IPaymentOption[]) {
        const paymentWrap = document.querySelector('#payment-methods-container') as HTMLElement;

        for (const paymentOptionInit of paymentOptionsInit) {
            const paymentOption = new models.PaymentOption(paymentOptionInit);
            const templateEl = template.Clone(document.querySelector('#payment-method-template') as HTMLTemplateElement);
            const templateElChild = templateEl.querySelector('#payment-elements') as HTMLElement;

            const paymentIcon = templateEl.querySelector('#payment-method-icon') as HTMLElement;
            const paymentMethodType = templateEl.querySelector('#payment-method-type') as HTMLElement;
            const lastFour = templateEl.querySelector('#last-four') as HTMLElement;
            const expiration = templateEl.querySelector('#expiration') as HTMLElement;
            const deletePaymentMethodBtn = templateEl.querySelector('#delete-payment-method') as HTMLElement;

            deletePaymentMethodBtn.addEventListener('click', () => {
                void paymentmethods.DeletePaymentOption(paymentOption.id || '').then(() => {
                    templateElChild.parentElement?.removeChild(templateElChild);
                    toast.Success('Removed Payment Method');
                });
            });

            if (paymentOption.paymentOptionTypeID === models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT) {
                paymentMethodType.textContent = 'Card';
                paymentIcon.classList.add('fas', 'fa-credit-card');
            }
            lastFour.textContent = paymentOption.creditCardLast4 ? `Ending in: ${paymentOption.creditCardLast4}` : '';
            expiration.textContent = paymentOption.creditCardExpirationDate ? `Expires: ${paymentOption.creditCardExpirationDate}` : '';

            // Checkout drops options whose stored phone fails the server tel validator; let the customer fix it here.
            if (!phone.IsValid(paymentOption.address.phoneNumber?.phone)) {
                templateElChild.appendChild(phone.InvalidPhoneNote());
            }

            paymentWrap.insertBefore(templateEl, paymentWrap.lastElementChild);
        }
    }
    const newPaymentMethodBtn = document.querySelector('#new-payment-method') as HTMLElement;

    newPaymentMethodBtn.addEventListener('click', () => {
        void PromptNewPaymentOption(
            sess.user,
            'Add payment method',
            [
                models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT,
            ],
        ).then(resp => drawPaymentMethods([models.PaymentOption.fromJSON(resp)]));
    });

    drawPaymentMethods(paymentOptions);
}
